import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-review-star-item',
  templateUrl: './review-star-item.component.html',
  styleUrls: ['./review-star-item.component.scss']
})
export class ReviewStarItemComponent implements OnInit {

  previousState: StarState;
  canReHover: boolean = true;
  @Input() isSelected: boolean = false;
  @Input() isHovered: boolean = false;
  @Input() state: StarState = StarState.empty;
  @Input() starID: number;
  @Output() onSelected = new EventEmitter<any>();
  @Output() onHovered = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onMouseOver(e: any) {

    let rect = e.target.getBoundingClientRect();
    let mousex = e.clientX - rect.left; //x position within the element.
    let mousey = e.clientY - rect.top;

    //mitad
    if (mousex < (rect.width / 2)) {
      let status: StarStateStruct = {
        id: this.starID,
        state: StarState.half,
        isSelected: false,
        isHovered: true,
      }
      if (this.canReHover) {
        this.onHovered.next(status);
      }
    }
    //entero
    if (mousex >= (rect.width / 2)) {
      let status: StarStateStruct = {
        id: this.starID,
        state: StarState.full,
        isSelected: false,
        isHovered: true,
      }
      if (this.canReHover) {
        this.onHovered.next(status);
      }
    }
  }

  onMouseClick(e: any) {
    let rect = e.target.getBoundingClientRect();
    let mousex = e.clientX - rect.left; //x position within the element.
    let mousey = e.clientY - rect.top;
    this.canReHover = false;

    //mitad
    if (mousex < (rect.width / 2)) {
      let status: StarStateStruct = {
        id: this.starID,
        state: StarState.half,
        isSelected: true,
        isHovered: false,
      }
      this.onSelected.next(status);
    }
    //entero
    if (mousex >= (rect.width / 2)) {
      let status: StarStateStruct = {
        id: this.starID,
        state: StarState.full,
        isSelected: true,
        isHovered: false,
      }
      this.onSelected.next(status);
    }

  }

  onMouseLeave(e: any) {
    this.canReHover = true;
  }

  changeState(nextState: StarState) {
    this.previousState = this.state;
    this.state = nextState;
  }

  public get StarState(): typeof StarState {
    return StarState;
  }

}

export interface StarStateStruct {
  id: number;
  state: StarState;
  isSelected: boolean;
  isHovered: Boolean;
}

export enum StarState {
  empty,
  half,
  full,
}